<template>
  <section id="products-panel">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div class="page-inner">
      <div class="content-panel">
        <products-title @get-products="getProducts" />

        <h2 v-if="!fetched" class="empty-state">
          Selecione uma loja e clique em Buscar para ver os produtos.
        </h2>

        <h2 v-else-if="products.length === 0" class="empty-state">
          Não existem produtos cadastrados nesta loja no momento :(
        </h2>

        <template v-else>
          <products-table :products="productsPaged" />

          <pagination
            v-if="totalPages > 1"
            :currentPage="currentPage"
            :totalPages="totalPages"
            @update:page="onPageChange"
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import productsTitle from "./ProductsTitle";
import productsTable from "./ProductsTable";
import pagination from "../common/Pagination";

export default {
  mixins: [common],

  components: {
    productsTitle,
    productsTable,
    pagination
  },

  data() {
    return {
      isLoading: false,
      fetched: false,
      currentPage: 1,
      perPage: 50
    };
  },

  computed: {
    ...mapGetters(["products"]),

    totalPages() {
      return Math.max(1, Math.ceil(this.products.length / this.perPage));
    },

    productsPaged() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.products.slice(start, start + this.perPage);
    }
  },

  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.$nextTick(() => {
        const panel = document.getElementById("products-panel");
        if (panel) panel.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    },

    getProducts({ storeId }) {
      this.isLoading = true;
      this.currentPage = 1;
      this.$store
        .dispatch("getProducts", storeId)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
          this.fetched = true;
        });
    }
  }
};
</script>

<style scoped>
#products-panel {
  min-height: 100vh;
  background-color: #f8f7fa;
  padding: 1.5rem;
}

.page-inner {
  width: 100%;
}

.content-panel {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.07), 0 1px 2px rgba(0, 0, 0, 0.04);
  border: 1px solid #f3f4f6;
  padding: 1.5rem;
}

.empty-state {
  padding: 3rem 0;
  color: #9ca3af;
  text-align: center;
  font-size: 0.95rem;
}
</style>
